import React, { useId, useMemo, useState } from "react";

export const getHtmlVariableToken = (variable) =>
  `{${String(variable?.shortDescription ?? "")}}`;

const normalizeSearchText = (value) =>
  String(value ?? "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLocaleLowerCase("it");

const HtmlVariablesPanel = ({ variables = [], loading = false, error = "" }) => {
  const searchInputId = useId();
  const [searchText, setSearchText] = useState("");

  const filteredVariables = useMemo(() => {
    const normalizedSearch = normalizeSearchText(searchText.trim());

    if (!normalizedSearch) return variables;

    return variables.filter((variable) =>
      [variable?.shortDescription, variable?.keyField]
        .some((value) => normalizeSearchText(value).includes(normalizedSearch))
    );
  }, [searchText, variables]);

  const handleDragStart = (event, variable) => {
    event.dataTransfer.setData("text/plain", getHtmlVariableToken(variable));
  };

  if (loading) {
    return (
      <div className="d-flex align-items-center text-muted py-3">
        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />
        Caricamento variabili...
      </div>
    );
  }

  if (error) {
    return <div className="alert alert-warning mb-0">{error}</div>;
  }

  if (!variables.length) {
    return <div className="text-muted py-3">Nessuna variabile disponibile.</div>;
  }

  return (
    <div>
      <p className="small text-muted mb-2">
        Trascina una variabile nell'editor per inserirla nella posizione desiderata.
      </p>
      <label className="form-label small fw-semibold" htmlFor={searchInputId}>
        Cerca variabile
      </label>
      <input
        id={searchInputId}
        type="search"
        className="form-control mb-2"
        placeholder="Cerca per nome..."
        value={searchText}
        onChange={(event) => setSearchText(event.target.value)}
      />
      <div className="small text-muted mb-2">
        {filteredVariables.length} di {variables.length} variabili
      </div>
      <div className="list-group overflow-auto" style={{ maxHeight: "620px" }}>
        {filteredVariables.map((variable, index) => {
          const description = String(variable?.shortDescription ?? "");

          return (
            <div
              key={variable?.id ?? variable?.keyField ?? `${description}-${index}`}
              draggable
              className="list-group-item text-start fc-event"
              onDragStart={(event) => handleDragStart(event, variable)}
              title="Trascina nell'editor"
              style={{
                cursor: "grab",
                border: "1px solid rgba(0, 0, 0, 0.08)",
                borderRadius: "4px",
                marginBottom: "4px",
                backgroundColor: "rgba(0, 0, 0, 0.015)",
              }}
            >
              {description}
            </div>
          );
        })}
        {!filteredVariables.length && (
          <div className="text-muted text-center py-3">
            Nessuna variabile corrisponde alla ricerca.
          </div>
        )}
      </div>
    </div>
  );
};

export default HtmlVariablesPanel;
